import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";

import { environment } from "../environments/environment";
import { User } from "../models/user.model";
import { UsersService } from "./users.service";

@Injectable({
    providedIn: 'root'
})

export class AuthService {

    private _token: string = "";
    public isAuthenticated: boolean = false;
    public user: User|null = null;
    public user$: Observable<User | null> = of(this.user)

    getToken() {

        if (this._token == '') {
            const restoredToken = localStorage.getItem("_token");
            const restoredUserstring = localStorage.getItem("_user");

            let restoredUser
            if(restoredUserstring !== null) {
                restoredUser = JSON.parse(restoredUserstring);
            } else {
                restoredUser = {}
            }

            if (restoredToken) {
                this.setToken(restoredToken);
                this.setUser(<User> restoredUser);
                this.isAuthenticated = true;

                console.log("restored token", restoredToken)
                console.log("restored user", restoredUser)
            }
        }

        return this._token;
    }

    setToken(token: string) {
        this._token = token

        if (token) {
            localStorage.setItem("_token", token)
        }
    }

    checkAuth() {
        //this.isAuthenticated = this.getToken().length > 0
        this.getToken();
    }

    setUser(user: User) {
        this.user = user
        this.user$ = of(user)
        localStorage.setItem("_user", JSON.stringify(user))
    }

    constructor(
        private http: HttpClient,
        //private userService: UsersService
    ) {
    }

    getAuthUser() {
        return this.user
    }

    restoreUser() {
        const restoredUserstring = localStorage.getItem("_user");

        let restoredUser
        if(restoredUserstring !== null) {
            restoredUser = JSON.parse(restoredUserstring);
        } else {
            restoredUser = {}
        }

        this.setUser(<User> restoredUser);
        this.isAuthenticated = true;
    }


    getUser() {

        if(this.user === null) {
            this.restoreUser();
            return this.user
        } else {    
            return this.user
        }
    }

    login(credentials: Object) {
        const endpoint = environment.apiUrl + "/api/login";
        return this.http.post(endpoint, credentials, {})
    }


    logout(credentials: Object) {

        const bearerToken = "Bearer " + this._token
        const endpoint = environment.apiUrl + "/api/logout";
        return this.http.post(
            endpoint,
            credentials,
            {
                headers: new HttpHeaders().set("Authorization", bearerToken)
            })
    }

    clearAuthData() {
        this.isAuthenticated = false;
        this._token = "";
        this.user = null;
        localStorage.removeItem("_token");
        localStorage.removeItem("_user");
    }
    autoLogin() {   
        const token = localStorage.getItem("_token")
        const user = localStorage.getItem("_user")

        if (token && user) {
            this._token = token
            this.user = JSON.parse(user)
            this.isAuthenticated = true
        } else {
            this.clearAuthData()
        }
    }


}